import {
    Dialog,
    DialogTitle,
    DialogContent,
    Button,
    TextField,
    RadioGroup,
    IconButton,
    Accordion,
    AccordionDetails,
    AccordionSummary,
    DialogActions,
    FormLabel
  } from "@mui/material";
  import { styled } from "@mui/material/styles";

  export const StyledDialog = styled(Dialog)`
    .MuiDialog-paper {
      background-color: #2d2b2c;
      color: #DCC6B7;
      width: 90%;
      max-width: 900px;
      box-sizing: border-box;
      padding: 32px 24px;
      border-radius: 16px;
      z-index: 9999;
      overflow: hidden;
      max-height: 100vh;
    }
  `;
  
  export const StyledDialogTitle = styled(DialogTitle)`
    color:  #DCC6B7;
    text-align: center;
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-transform: uppercase;
    margin-bottom: 14px;
  `;
  
  export const StyledDialogContent = styled(DialogContent)`
    width: 100%;
    color: #ffffff;
    font-size: 1rem;
    padding: 0;
    overflow: hidden;
    max-width: 100%;
  `;
  
  export const StyledDialogInputs = styled("div")`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 24px;
    width: 100%;
  
    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  `;
  
  export const StyledButton = styled(Button)`
    background-color: #d7bcae;
    color: #2d2b2c;
    font-weight: bold;
    font-size: 0.875rem;
    padding: 12px;
    box-sizing: border-box;
    border-radius: 8px;
    width: 100%;
  
    &:hover {
      background-color: #bfa798;
    }

     &.Mui-disabled {
      opacity: 0.5;
      color: #2d2b2c; /* mantém a cor original */
      background-color: #d7bcae; /* mantém a cor original */
    }
  `;
  
  export const StyledSecondaryButton = styled(Button)`
    color: #d7bcae;
    border: 1px solid #d7bcae;
    padding: 12px;
    font-size: 0.875rem;
    font-weight: bold;
    box-sizing: border-box;
    border-radius: 8px;
    width: 100%;
  
    &:hover {
      background-color: rgba(215, 188, 174, 0.2);
    }
  `;
  
  export const StyledRadioGroup = styled(RadioGroup)`
    flex-direction: row;
  `;
  
  export const StyledDialogCloseButton = styled(IconButton)`
    position: absolute;
    right: 8px;
    top: 8px;
    color: #DCC6B7;
  `;
  
  export const StyledAccordion = styled(Accordion)`
    background: transparent;
    box-shadow: none;
    &::before {
      display: none;
    }
  `;

  export const StyledAccordionDetails = styled(AccordionDetails)`
    margin-top: 0 !important;
    padding-top: 0 !important;
    padding-bottom: 0;
    display: flex;
    flex-direction: column;
    gap: 16px;
`;
  
  export const StyledTextField = styled(TextField)(({ theme }) => ({
  '& input::placeholder': {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: '#d7bcae',
    [theme.breakpoints.down('sm')]: {
      fontSize: 'clamp(0.9rem, 4vw, 1.25rem)',
    },
    [theme.breakpoints.up('sm')]: {
      fontSize: '1rem',
    },
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: '#dcc6b7',
    },
    '&:hover fieldset': {
      borderColor: '#dcc6b7',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#dcc6b7',
    },
  },
  '& .MuiInputLabel-root': {
    color: '#dcc6b7',
  },
}));



  export const StyledFormLabel = styled(FormLabel)`
    color: #ffffff;
    font-weight: 500;
    margin-bottom: 4px;
  `;

  
  export const StyledAccordionSummary = styled(AccordionSummary)`
    display: flex;
    align-items: center;
    justify-content: flex-start;
  
    .MuiAccordionSummary-content {
      margin: 0;
      flex-grow: 0;
    }
  
    .MuiAccordionSummary-expandIconWrapper {
      color: #d7bcae;
      margin-left: 8px; 
      margin-right: auto; 
    }
  `;
  
  
  
  export const TitleWithAccordionWrapper = styled('div')`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px; 
  `;
  
  export const StyledDialogActions = styled(DialogActions)(({ theme, isMobile }) => ({
    flexDirection: isMobile ? 'column-reverse' : 'row',
    alignItems: 'center',
    justifyContent: isMobile ? 'center' : 'flex-end',
    gap: theme.spacing(2),
    marginTop: theme.spacing(3),
    padding: 0,
    width: '100%',
  
    '& > :not(:first-of-type)': {
      marginLeft: 0,
    },
  }));